var map = {
	"./CSRealCase1-en-moblie.jpg": 796,
	"./CSRealCase1-en.jpg": 797,
	"./CSRealCase1-moblie.jpg": 798,
	"./CSRealCase1.jpg": 799,
	"./CSRealCase2-en-moblie.jpg": 800,
	"./CSRealCase2-en.jpg": 801,
	"./CSRealCase2-moblie.jpg": 802,
	"./CSRealCase2.jpg": 803,
	"./CSRealCase3-en-moblie.jpg": 804,
	"./CSRealCase3-en.jpg": 805,
	"./CSRealCase3-moblie.jpg": 806,
	"./CSRealCase3.jpg": 807,
	"./CommonInternetWhalingAttacks1.jpg": 808,
	"./CommonInternetWhalingAttacks2.jpg": 809,
	"./CommonInternetWhalingAttacks3.jpg": 810,
	"./CommonInternetWhalingAttacks4.jpg": 811,
	"./CustomerRealCase1-en-moblie.jpg": 812,
	"./CustomerRealCase1-en.jpg": 813,
	"./CustomerRealCase1-moblie.jpg": 814,
	"./CustomerRealCase1.jpg": 815,
	"./E-commerceRealCase1-en.jpg": 816,
	"./E-commerceRealCase1-moblie-en.jpg": 817,
	"./E-commerceRealCase1-moblie.jpg": 818,
	"./E-commerceRealCase1.jpg": 819,
	"./E-commerceRealCase2-en.jpg": 820,
	"./E-commerceRealCase2-mobile.jpg": 821,
	"./E-commerceRealCase2-moblie-en.jpg": 822,
	"./E-commerceRealCase2-moblie.jpg": 823,
	"./E-commerceRealCase2.jpg": 824,
	"./FinanceRealCase-en.jpg": 825,
	"./FinanceRealCase-mobile-en.jpg": 826,
	"./FinanceRealCase-mobile-sc.jpg": 827,
	"./FinanceRealCase-mobile.jpg": 828,
	"./FinanceRealCase-sc.jpg": 829,
	"./FinanceRealCase.jpg": 830,
	"./FinanceRealCase2-en.jpg": 831,
	"./FinanceRealCase2-mobile-en.jpg": 832,
	"./FinanceRealCase2-mobile-sc.jpg": 833,
	"./FinanceRealCase2-mobile.jpg": 834,
	"./FinanceRealCase2-sc.jpg": 835,
	"./FinanceRealCase2.jpg": 836,
	"./HRRealCase-en.jpg": 837,
	"./HRRealCase-mobile-en.jpg": 838,
	"./HRRealCase-mobile.jpg": 839,
	"./HRRealCase.jpg": 840,
	"./ITRealCase1-en.jpg": 841,
	"./ITRealCase1-moblie-en.jpg": 842,
	"./ITRealCase1-moblie.jpg": 843,
	"./ITRealCase1.jpg": 844,
	"./ITRealCase2-en.jpg": 845,
	"./ITRealCase2-moblie-en.jpg": 846,
	"./ITRealCase2-moblie.jpg": 847,
	"./ITRealCase2.jpg": 848,
	"./ITRealCase3-en.jpg": 849,
	"./ITRealCase3-moblie-en.jpg": 850,
	"./ITRealCase3-moblie.jpg": 851,
	"./ITRealCase3.jpg": 852,
	"./IndexPrompt.jpg": 853,
	"./MarketRealCase.jpg": 854,
	"./MarketRealCase1-en-moblie.jpg": 855,
	"./MarketRealCase1-en.jpg": 856,
	"./MarketRealCase1-moblie.jpg": 857,
	"./MarketRealCase1.jpg": 858,
	"./MarketRealCase2-en-moblie.jpg": 859,
	"./MarketRealCase2-en.jpg": 860,
	"./MarketRealCase2-moblie.jpg": 861,
	"./MarketRealCase2.jpg": 862,
	"./MarketRealCase3-en.jpg": 863,
	"./NGORealCase1-en.jpg": 864,
	"./NGORealCase1-moblie-en.jpg": 865,
	"./NGORealCase1-moblie.jpg": 866,
	"./NGORealCase1.jpg": 867,
	"./NGORealCase2-en.jpg": 868,
	"./NGORealCase2-moblie-en.jpg": 869,
	"./NGORealCase2-moblie.jpg": 870,
	"./NGORealCase2.jpg": 871,
	"./RealCase-mobile-en.jpg": 872,
	"./RealCase-mobile-sc.jpg": 873,
	"./RealCase-sc.jpg": 874,
	"./RealCase.mobile.jpg": 875,
	"./Realcase-socialMedia-mobile.jpg": 876,
	"./Realcase-socialMedia.jpg": 877,
	"./a004-a.jpg": 878,
	"./a004-b.jpg": 879,
	"./a004-example1-en.jpg": 880,
	"./a004-example1-sc.jpg": 881,
	"./a004-example1.jpg": 882,
	"./a004-example2.jpg": 883,
	"./a004-example3.jpg": 884,
	"./a008-tip.jpg": 885,
	"./a009-tip1.jpg": 886,
	"./a009-tip2.jpg": 887,
	"./a009-tip3.jpg": 888,
	"./a011-01.jpg": 889,
	"./a011-010.jpg": 890,
	"./a011-011.jpg": 891,
	"./a011-012.jpg": 892,
	"./a011-02.jpg": 893,
	"./a011-03.jpg": 894,
	"./a011-04.jpg": 895,
	"./a011-05.jpg": 896,
	"./a011-06.jpg": 897,
	"./a011-07.jpg": 898,
	"./a011-08.jpg": 899,
	"./a011-09.jpg": 900,
	"./a011-example1.jpg": 901,
	"./a011-example2.jpg": 902,
	"./a011-example3.jpg": 903,
	"./a011-example5.jpg": 904,
	"./a011-example6.jpg": 905,
	"./a011-example7.jpg": 906,
	"./a011-example8.jpg": 907,
	"./a016-1.jpg": 908,
	"./a016-2.jpg": 909,
	"./a016-3.jpg": 910,
	"./a016-4.jpg": 911,
	"./a016-5.jpg": 912,
	"./a016-6.jpg": 913,
	"./a016-market-1.jpg": 914,
	"./a016-market-2.jpg": 915,
	"./a016-market-3.jpg": 916,
	"./a016-market-4.jpg": 917,
	"./a019-tip-en.jpg": 918,
	"./a019-tip.jpg": 919,
	"./a021-viewmore-en.jpg": 920,
	"./a021-viewmore-fsi.jpg": 921,
	"./a021-viewmore.jpg": 922,
	"./a023-short1.jpg": 428,
	"./a023-short2.jpg": 429,
	"./a023-short3.jpg": 430,
	"./a023-short4.jpg": 431,
	"./a023-short5.jpg": 432,
	"./a023-short6.jpg": 433,
	"./a026-example1.jpg": 961,
	"./a026-example2.jpg": 962,
	"./a026-example3.jpg": 963,
	"./a026-example4.jpg": 964,
	"./a026-example5.jpg": 965,
	"./a026-example6.jpg": 966,
	"./a026-example7.jpg": 967,
	"./a028-example1.jpg": 974,
	"./a028-example2.jpg": 975,
	"./a028-example3.jpg": 976,
	"./a037-a.jpg": 977,
	"./a037-b.jpg": 978,
	"./a037-c.jpg": 979,
	"./a037-d.jpg": 980,
	"./a037-e.jpg": 981,
	"./a037-f.jpg": 982,
	"./a037-g.jpg": 983,
	"./a037-h.jpg": 984,
	"./a037-i.jpg": 985,
	"./a037-j.jpg": 986,
	"./a037-k.jpg": 987,
	"./a037-l.jpg": 988,
	"./a037-m.jpg": 989,
	"./a037-n.jpg": 990,
	"./aiSecurityRealcase-en.jpg": 991,
	"./aiSecurityRealcase-mobile-en.jpg": 992,
	"./aiSecurityRealcase-mobile.jpg": 993,
	"./aiSecurityRealcase.jpg": 994,
	"./c001-E-commerce-1.jpg": 995,
	"./c001-E-commerce-2.jpg": 996,
	"./c001-E-commerce-3.jpg": 997,
	"./c001-E-commerce-4.jpg": 998,
	"./c001-E-commerce-5.jpg": 999,
	"./c001-E-commerce-6.jpg": 1000,
	"./c001-Picture1.jpg": 1001,
	"./c001-Picture2.jpg": 1002,
	"./c001-Picture3.jpg": 1003,
	"./c001-fsi-1.jpg": 1004,
	"./c001-fsi-2.jpg": 1005,
	"./c001-fsi-3.jpg": 1006,
	"./c001-fsi-4.jpg": 1007,
	"./c001-ngo-1.jpg": 1008,
	"./c001-ngo-2.jpg": 1009,
	"./c001-ngo-3.jpg": 1010,
	"./c001-ngo-4.jpg": 1011,
	"./c001-ngo-5.jpg": 1012,
	"./c001-student-1.jpg": 1013,
	"./c001-student-2.jpg": 1014,
	"./c001-student-3.jpg": 1015,
	"./c001-student-4.jpg": 1016,
	"./c001-student-5.jpg": 1017,
	"./c001-student-6.jpg": 1018,
	"./c001-student-7.jpg": 1019,
	"./c001-student-8.jpg": 1020,
	"./c002-example1.jpg": 1021,
	"./c002-general2024-example1.jpg": 1022,
	"./c006-1.jpg": 1023,
	"./c006-2.jpg": 1024,
	"./c006-3.jpg": 1025,
	"./c006-4.jpg": 1026,
	"./c006-5.jpg": 1027,
	"./c006-6.jpg": 1028,
	"./c006-a.jpg": 1029,
	"./c006-b.jpg": 1030,
	"./c006-c.jpg": 1031,
	"./c006-d.jpg": 1032,
	"./c007-1.jpg": 1033,
	"./c007-bg.jpg": 1034,
	"./cert/cert-E-commerce-HKIRC.jpg": 1035,
	"./cert/cert-E-commerce-consumer.jpg": 1036,
	"./cert/cert-E-commerce-cpttm.jpg": 434,
	"./cert/cert-E-commerce-hkgcsmeaa.jpg": 1037,
	"./cert/cert-customer-HKIRC.jpg": 1038,
	"./cert/cert-customer-consumer.jpg": 1039,
	"./cert/cert-customer-cpttm.jpg": 435,
	"./cert/cert-customer-hkgcsmeaa.jpg": 1040,
	"./cert/cert-finance-HKIRC-sc.jpg": 1041,
	"./cert/cert-finance-HKIRC.jpg": 1042,
	"./cert/cert-finance-consumer-sc.jpg": 1043,
	"./cert/cert-finance-consumer.jpg": 1044,
	"./cert/cert-finance-cpttm-sc.jpg": 436,
	"./cert/cert-finance-cpttm.jpg": 437,
	"./cert/cert-finance-hkgcsmeaa-sc.jpg": 1045,
	"./cert/cert-finance-hkgcsmeaa.jpg": 1046,
	"./cert/cert-fsi-HKIRC-sc.jpg": 1047,
	"./cert/cert-fsi-HKIRC.jpg": 1048,
	"./cert/cert-fsi-consumer-sc.jpg": 1049,
	"./cert/cert-fsi-consumer.jpg": 1050,
	"./cert/cert-fsi-cpttm-sc.jpg": 438,
	"./cert/cert-fsi-cpttm.jpg": 439,
	"./cert/cert-fsi-hkgcsmeaa-sc.jpg": 1051,
	"./cert/cert-fsi-hkgcsmeaa.jpg": 1052,
	"./cert/cert-general-staff-HKIRC-sc.jpg": 1053,
	"./cert/cert-general-staff-HKIRC.jpg": 1054,
	"./cert/cert-general-staff-a-HKIRC-sc.jpg": 1055,
	"./cert/cert-general-staff-a-HKIRC.jpg": 1056,
	"./cert/cert-general-staff-a-consumer-sc.jpg": 1057,
	"./cert/cert-general-staff-a-consumer.jpg": 1058,
	"./cert/cert-general-staff-a-cpttm-sc.jpg": 440,
	"./cert/cert-general-staff-a-cpttm.jpg": 441,
	"./cert/cert-general-staff-a-hkgcsmeaa-sc.jpg": 1059,
	"./cert/cert-general-staff-a-hkgcsmeaa.jpg": 1060,
	"./cert/cert-general-staff-consumer-sc.jpg": 1061,
	"./cert/cert-general-staff-consumer.jpg": 1062,
	"./cert/cert-general-staff-cpttm-sc.jpg": 442,
	"./cert/cert-general-staff-cpttm.jpg": 443,
	"./cert/cert-general-staff-hkgcsmeaa-sc.jpg": 1063,
	"./cert/cert-general-staff-hkgcsmeaa.jpg": 1064,
	"./cert/cert-general2024-HKIRC-sc.jpg": 1065,
	"./cert/cert-general2024-HKIRC.jpg": 1066,
	"./cert/cert-general2024-consumer-sc.jpg": 1067,
	"./cert/cert-general2024-consumer.jpg": 1068,
	"./cert/cert-general2024-cpttm-sc.jpg": 370,
	"./cert/cert-general2024-cpttm.jpg": 371,
	"./cert/cert-general2024-hkgcsmeaa-sc.jpg": 1069,
	"./cert/cert-general2024-hkgcsmeaa.jpg": 1070,
	"./cert/cert-hr-HKIRC.jpg": 1071,
	"./cert/cert-hr-consumer.jpg": 1072,
	"./cert/cert-hr-cpttm.jpg": 444,
	"./cert/cert-hr-hkgcsmeaa.jpg": 1073,
	"./cert/cert-it-HKIRC.jpg": 1074,
	"./cert/cert-it-consumer.jpg": 1075,
	"./cert/cert-it-cpttm.jpg": 445,
	"./cert/cert-it-hkgcsmeaa.jpg": 1076,
	"./cert/cert-market-HKIRC.jpg": 1077,
	"./cert/cert-market-consumer.jpg": 1078,
	"./cert/cert-market-cpttm.jpg": 446,
	"./cert/cert-market-hkgcsmeaa.jpg": 1079,
	"./cert/cert-ngo-HKIRC.jpg": 1080,
	"./cert/cert-ngo-consumer.jpg": 1081,
	"./cert/cert-ngo-cpttm.jpg": 447,
	"./cert/cert-ngo-hkgcsmeaa.jpg": 1082,
	"./cert/cert-senior-manager-HKIRC-sc.jpg": 1083,
	"./cert/cert-senior-manager-HKIRC.jpg": 1084,
	"./cert/cert-senior-manager-consumer-sc.jpg": 1085,
	"./cert/cert-senior-manager-consumer.jpg": 1086,
	"./cert/cert-senior-manager-cpttm-sc.jpg": 448,
	"./cert/cert-senior-manager-cpttm.jpg": 449,
	"./cert/cert-senior-manager-hkgcsmeaa-sc.jpg": 1087,
	"./cert/cert-senior-manager-hkgcsmeaa.jpg": 1088,
	"./cert/cert-startup-HKIRC.jpg": 1089,
	"./cert/cert-startup-consumer.jpg": 1090,
	"./cert/cert-startup-cpttm.jpg": 450,
	"./cert/cert-startup-hkgcsmeaa.jpg": 1091,
	"./cert/cert-student-HKIRC-sc.jpg": 1092,
	"./cert/cert-student-HKIRC.jpg": 1093,
	"./cert/cert-student-consumer-sc.jpg": 1094,
	"./cert/cert-student-consumer.jpg": 1095,
	"./cert/cert-student-cpttm-sc.jpg": 451,
	"./cert/cert-student-cpttm.jpg": 452,
	"./cert/cert-student-hkgcsmeaa-sc.jpg": 1096,
	"./cert/cert-student-hkgcsmeaa.jpg": 1097,
	"./dataLeakageRealcase-en.jpg": 1098,
	"./dataLeakageRealcase-mobile-en.jpg": 1099,
	"./dataLeakageRealcase-mobile.jpg": 1100,
	"./dataLeakageRealcase.jpg": 1101,
	"./education/topic1000/panelData4.jpg": 386,
	"./education/topic1000/panelData6.jpg": 387,
	"./fsiRealCase1-en.jpg": 1102,
	"./fsiRealCase1-mobile-en.jpg": 1103,
	"./fsiRealCase1-mobile-sc.jpg": 1104,
	"./fsiRealCase1-mobile.jpg": 1105,
	"./fsiRealCase1-sc.jpg": 1106,
	"./fsiRealCase1.jpg": 1107,
	"./fsiRealCase2-en-mobile.jpg": 1108,
	"./fsiRealCase2-en.jpg": 1109,
	"./fsiRealCase2-mobile-sc.jpg": 1110,
	"./fsiRealCase2-mobile.jpg": 1111,
	"./fsiRealCase2-sc.jpg": 1112,
	"./fsiRealCase2.jpg": 1113,
	"./general2024RealCase1-en-mobile.jpg": 1114,
	"./general2024RealCase1-en.jpg": 1115,
	"./general2024RealCase1-mobile-sc.jpg": 1116,
	"./general2024RealCase1-mobile.jpg": 1117,
	"./general2024RealCase1-sc.jpg": 1118,
	"./general2024RealCase1.jpg": 1119,
	"./it900-a031-en.jpg": 1120,
	"./it900-a031.jpg": 1121,
	"./it900-a32-1.jpg": 1122,
	"./it900-a32-2.jpg": 1123,
	"./it900-a32-3.jpg": 1124,
	"./it930-a033-1.jpg": 1125,
	"./it930-a033-2.jpg": 1126,
	"./it930-a033-3.jpg": 1127,
	"./it930-a033-4.jpg": 1128,
	"./it930-a033-5-en.jpg": 1129,
	"./it930-a033-5.jpg": 1130,
	"./lady-right.jpg": 1131,
	"./man-right.jpg": 1132,
	"./man.jpg": 1133,
	"./news-mobile-en.jpg": 1134,
	"./news-mobile-sc.jpg": 1135,
	"./news-mobile.jpg": 1136,
	"./news-sc.jpg": 1137,
	"./news.jpg": 1138,
	"./ngo-a035-1.jpg": 1139,
	"./ngo-a035-2.jpg": 1140,
	"./ngo-a035-3.jpg": 1141,
	"./ngo-a035-4.jpg": 1142,
	"./ngo-a036-example.jpg": 1143,
	"./p-onprogress-B.jpg": 1144,
	"./s3-004.jpg": 1145,
	"./s3-005.jpg": 1146,
	"./s3-006.jpg": 1147,
	"./s3-007.jpg": 1148,
	"./s3-008.jpg": 1149,
	"./startupRealCase1-en.jpg": 1150,
	"./startupRealCase1-mobile-en.jpg": 1151,
	"./startupRealCase1-mobile.jpg": 1152,
	"./startupRealCase1.jpg": 1153,
	"./startupRealCase2-en.jpg": 1154,
	"./startupRealCase2-mobile-en.jpg": 1155,
	"./startupRealCase2-mobile.jpg": 1156,
	"./startupRealCase2.jpg": 1157,
	"./studentRealCase1-mobile-sc.jpg": 1158,
	"./studentRealCase1-sc.jpg": 1159,
	"./studentRealCase2-mobile-sc.jpg": 1160,
	"./studentRealCase2-sc.jpg": 1161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3419;